import * as React from "react"

import { cn } from "@/lib/utils"

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "cy:border-input cy:placeholder:text-muted-foreground cy:focus-visible:border-ring cy:focus-visible:ring-ring/50 cy:aria-invalid:ring-destructive/20 cy:dark:aria-invalid:ring-destructive/40 cy:aria-invalid:border-destructive cy:dark:bg-input/30 cy:flex cy:field-sizing-content cy:min-h-16 cy:w-full cy:rounded-md cy:border cy:bg-transparent cy:px-3 cy:py-2 cy:text-base cy:shadow-xs cy:transition-[color,box-shadow] cy:outline-none cy:focus-visible:ring-[3px] cy:disabled:cursor-not-allowed cy:disabled:opacity-50 cy:md:text-sm",
        className
      )}
      {...props}
    />
  )
}

export { Textarea }
